
import { mapState } from "vuex";
import currencyConverter from "../common/currency-converter.vue";

export default {
  components: { currencyConverter },
  name: "OrderDetailsPriceBreakup",
  computed: {
    ...mapState("reciever", ["orderDetails"]),
    ...mapState("restaurant", ["locationDetails"]),
    isWhatsappOrder() {
      return (
        this.getChannelConstObj(this.orderDetails.source).name ===
        this.$constants.Channels.WHATSAPP.name
      );
    },
    isOwnDelivery() {
      return this.orderDetails.delivery_partner === "own_delivery";
    },
    getDeliveryCharge() {
      const deliveryCharge = this.orderDetails?.other_prices?.find((price) => {
        return price.name == "Delivery Charge";
      });

      if (deliveryCharge) {
        if (
          deliveryCharge.value &&
          deliveryCharge.value.total !== undefined &&
          deliveryCharge.value.total !== null
        ) {
          return deliveryCharge.value.total;
        } else {
          return deliveryCharge.value !== undefined ? deliveryCharge.value : 0;
        }
      } else {
        return 0;
      }
    },
    getCgst() {
      return (
        this.orderDetails?.other_prices?.find((price) => price.name === "CGST")
          ?.value ?? 0
      );
    },
    getSgst() {
      return (
        this.orderDetails?.other_prices?.find((price) => price.name === "SGST")
          ?.value ?? 0
      );
    },
    getTotalDeliveryCharge() {
      return (
        this.orderDetails?.other_prices?.find(
          (price) => price.name === "Delivery Charge"
        )?.value?.total ?? 0
      );
    },
    getCustomerDeliveryCharge() {
      return (
        this.orderDetails?.other_prices?.find(
          (price) => price.name === "Delivery Charge"
        )?.value?.customer ?? 0
      );
    },
    getRestaurantDeliveryCharge() {
      return (
        this.orderDetails?.other_prices?.find(
          (price) => price.name === "Delivery Charge"
        )?.value?.restaurant ?? 0
      );
    },
    getPackingCharge() {
      const found = this.orderDetails?.other_prices?.filter((price) => {
        return (
          price.name == "Packaging Charge" ||
          price.name == "Restaurant Packaging Charges"
        );
      });

      if (found && found.length) {
        return found
          .map((item) => item.value)
          .reduce((prev, next) => prev + next);
      }
      if (this.orderDetails?.order_level_total_charges) {
        return this.orderDetails.order_level_total_charges;
      }
      if (this.orderDetails?.item_level_total_charges) {
        return this.orderDetails.item_level_total_charges;
      }
      return 0;
    },
    getMerchantDiscount() {
      const discount = this.orderDetails?.discount
        ? this.orderDetails.discount
        : 0;
      const externalDiscount = this.orderDetails?.total_external_discount
        ? this.orderDetails.total_external_discount
        : 0;

      return discount - externalDiscount;
    },

    getAggregatorDiscount() {
      if (this.orderDetails && this.orderDetails.total_external_discount) {
        return this.orderDetails.total_external_discount;
      } else {
        return 0;
      }
    },
    getRounding() {
      if (this.orderDetails && this.orderDetails.round_off) {
        return Math.abs(this.orderDetails.round_off) / 100;
      } else {
        return 0;
      }
    },
    getTotal() {
      if (this.orderDetails && this.orderDetails.payable_amount) {
        return this.orderDetails.payable_amount;
      } else {
        return 0;
      }
    }
  }
};
